import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLocation } from "react-router-dom";
import { startAuthKeepAlive, stopAuthKeepAlive } from "@/utils/authKeepAlive";

export const KeepAliveManager = () => {
  const { session } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (session) {
      // Start keep-alive when session is active
      const currentPath = location.pathname;
      if (currentPath !== '/suspended' && currentPath !== '/deactivated') {
        startAuthKeepAlive();
      } else {
        stopAuthKeepAlive();
      }
      
      return () => {
        stopAuthKeepAlive();
      };
    } else {
      // Stop keep-alive when no session
      stopAuthKeepAlive();
    }
  }, [session, location.pathname]);

  return null; // This component doesn't render anything
};

